/* import __COLOCATED_TEMPLATE__ from './settings-component.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

const SECTION_MODEL_MAP = {
  'operator-inbox': 'botInboxSettings',
  'custom-bot': 'customBotsSettings',
};
export default class SettingsComponent extends Component {
  @service intercomEventService;
  @service intercomConfirmService;
  @service notificationsService;
  @service appService;
  @service permissionsService;
  @service intl;

  get app() {
    return this.appService.app;
  }

  get botInboxSubheading() {
    return this.intl.t('operator.settings.turn-on-bot-inbox-channel.sub-title');
  }

  get identitySubheading() {
    return this.intl.t('operator.settings.choose-identity-for-bots.sub-title');
  }

  @action
  sectionDidOpen(sectionName) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'opened',
      context: 'operator_settings',
      object: `${sectionName}-section`,
    });
  }

  @action
  sectionDidClose(sectionName) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'closed',
      context: 'operator_settings',
      object: `${sectionName}-section`,
    });
  }

  @action
  async sectionCanClose(sectionName) {
    let model = SECTION_MODEL_MAP[sectionName];
    let confirmNotSaved = {
      title: this.intl.t('operator.settings.confirm-not-saved.close-without-saving'),
      primaryButtonType: 'primary-destructive',
      confirmButtonText: this.intl.t('operator.settings.confirm-not-saved.continue-without-saving'),
      cancelButtonText: this.intl.t('operator.settings.confirm-not-saved.keep-editing'),
      body: this.intl.t('operator.settings.confirm-not-saved.body'),
    };

    if (!model || !model.hasDirtyAttributes) {
      return true;
    }

    let confirmed = await this.intercomConfirmService.confirm(confirmNotSaved);

    if (confirmed) {
      model.rollbackAttributes();
      return true;
    } else {
      return false;
    }
  }

  @action
  toggleOperatorInboxSetting() {
    this.args.botInboxSettings.toggleProperty('assignConversationsToBots');

    if (!this.args.botInboxSettings.assignConversationsToBots) {
      this.args.botInboxSettings.deferSlas = false;
    }
  }

  @action
  trackOperatorInboxSettingsChange() {
    this.intercomEventService.trackAnalyticsEvent({
      context: 'bot_inbox_settings',
      object: 'bot_inbox_toggle',
      action: this.args.botInboxSettings.assignConversationsToBots ? 'turned_on' : 'turned_off',
    });
  }

  @action
  trackCustomBotAutoCloseSettings() {
    let settingSnapshot = this.args.customBotsSettings.getProperties(
      'autoClosingForUsers',
      'autoClosingForVisitors',
      'autoClosingFromButton',
      'autoClosingFromNewConversationUsers',
      'autoClosingFromNewConversationVisitors',
      'autoClosingConversationStarted',
      'autoClosingTimerMinutes',
    );

    this.intercomEventService.trackAnalyticsEvent({
      context: 'bot_inbox_settings',
      object: 'custom_bot_auto_close_settings',
      action: 'save',
      ...settingSnapshot,
    });
  }
}
